import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  plugins,
} from 'chart.js';

// Register required components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const options = {
  scales: {
    x: {
      title: {
        display: true,
        text: 'Grade',
      },
    },
    y: {
      title: {
        display: true,
        text: 'Number of participants',
      },
      beginAtZero: true,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: true,
      text: 'Attribute Score Distribution',
    }
  },
};

const BarChart = ({ scores, rubrik }) => {
  // Create bins for 1-5, 6-10, ..., 96-100
  // const binSize = config.barSize || 25;
  // const bins = Array.from({ length: 100 / binSize }, (_, i) => ({
  //   label: `${i * binSize + 1}-${(i + 1) * binSize}`,
  //   count: 0,
  // }));
  const bins = Object.entries(rubrik).map(([grade, { color, min, max }]) => (
    {
      size: max - min,
      label: grade,
      color: color,
      min: min,
      max: max,
    }
  )).sort((a, b) => b.min - a.min);

  // Group counts by bin
  const binCounts = bins.map(b => scores[b.label]); 

  // Prepare data for Bar chart
  const barData = {
    labels: bins.map(bin => bin.label),
    datasets: [
      {
        data: binCounts,
        backgroundColor: bins.map(b => b.color),
        borderColor: bins.map(b => b.color),
        borderWidth: 1,
      },
    ],
  };

  const totalVotes = binCounts.reduce((sum, count) => sum + count, 0);
  options.scales.y.max = totalVotes > 0 ? totalVotes : 5;
  return <Bar data={barData} options={options} />;
}

export default BarChart;